<template>
    <div :class="$route.name=='ProductDetails'?'breadcrumb2':'breadcrumb'">
        <div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item v-for="(item,index) in $route.meta.breadcrumb" :key="index"
                    :to="{ path: item.path }">
                    {{item.label}}
                </el-breadcrumb-item>
                <el-breadcrumb-item><span style="color: #D70606;">{{$route.meta.name}}</span></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Breadcrumb",
        data() {
            return {}
        },
        created() {}
    };
</script>
<style scoped>
    .breadcrumb {
        background-color: #FFFFFF;
    }

    .breadcrumb2>div,
    .breadcrumb>div {
        width: 1200px;
        height: 48px;
        margin: 0 auto;
        padding: 14px 0;
        box-sizing: border-box;
    }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue